module.exports = __webpack_public_path__ + "img/1516676014.6865b7ea.jpg";